module.exports = require("../d") + require("./dupdep");
var ep = "ep";
require("./dupd" + ep);



/*****************
 ** WEBPACK FOOTER
 ** ./compile/deduplication/dedupe2/index.js
 ** module id = 2
 ** module chunks = 0
 **/